import React from 'react';
import _ from 'lodash';
import Link from './Link';
import component, {classnames} from './component';
import tournamentStatuses from './tournamentStatuses';
import emptyPic from './emptyPic';

import Ellipsis from './MultilineEllipsis';

import {displayDateRangeTitle, displayDateRange} from './pages/TournamentDetails';
import {dateTime, dateTimeYear} from './DateFormats';

export default component('TournamentAnnouncement', function({picPosition, description, details, data, isListItem}) {
  if (!data) {
    return null;
  }

  let status = data.get('status');
  const hasButton = status === tournamentStatuses.registration.id && !isListItem;
  // output all statuses but `in_progress`
  const st = _.find(tournamentStatuses, ts => ts.id === status);
  const statusText = st && st.name;

  let hasLargeHeader = !details && !description || (details && hasButton) || isListItem;


  let url = data.get('image')?
    picPosition === 'left' && isListItem
      ? `url(${data.get('image')}?crop=1&w=160&h=160)`
      : `url(${data.get('image')}?crop=1&w=${details ? 604 : 288}&h=272)`
  : 'none';

  function getDates(data) {
    if(!data.getIn(['dates', 'from']) || !data.getIn(['dates', 'to'])){
      return null;
    }
    return (
      <div className="TournamentWidget-ContentDetailsItem">
        <div className="TournamentWidget-ContentDetailsItemTitle">{displayDateRangeTitle(data.get('dates'), 'Дата', 'Период')} проведения</div>
        <div className="TournamentWidget-ContentDetailsItemValue">{displayDateRange(data.get('dates'), status === tournamentStatuses.finished.id)}</div>
      </div>
    );
  }

  return (
    <div className={classnames('TournamentWidget', 'TournamentWidget-Image'+_.capitalize(picPosition), isListItem && 'TournamentWidget--ListItem')}>
      <Link className="TournamentWidget-Link" name="tournamentDetails" params={{id: data.get('id')}}>
        <div className={classnames('TournamentWidget-Image', picPosition === 'left' && (!isListItem && 'BaseColumnWidth' || 'TournamentWidget-ImageListItemPic'))}
             style={{backgroundImage: url}}>

        </div>
        <div
          className={classnames('TournamentWidget-RegistrationStatus', 'TournamentWidget-RegistrationStatus--' + status)}>
            {statusText}
        </div>
      </Link>

      <div className={classnames('TournamentWidget-Content', hasLargeHeader && 'TournamentWidget-Content--HasLargeHeader')}>
        <div className="TournamentWidget-ContentDescription">
          <h1><Link name="tournamentDetails" params={{id: data.get('id')}}>{data.get('title')}</Link></h1>
          {description && <Ellipsis className="TournamentWidget--Ellipsis">{data.get('short_description')}</Ellipsis>}
        </div>
        <div className="TournamentWidget-ContentBottom">
        {details && (status === tournamentStatuses.registration.id || isListItem) &&
          <div className="TournamentWidget-ContentDetails">
            {getDates(data)}
            {(data.get('confirmed_teams') || data.get('team_limit')) &&
              <div className="TournamentWidget-ContentDetailsItem">
                <div className="TournamentWidget-ContentDetailsItemTitle">КОМАНДЫ</div>
                <div className="TournamentWidget-ContentDetailsItemValue">
                  {data.get('confirmed_teams')
                      ? <span>{data.get('confirmed_teams')}/{data.get('team_limit')}</span>
                      : <span>{data.get('team_limit')}</span>
                  }
                </div>
              </div>
            }
            {data.get('prize') &&
              <div className="TournamentWidget-ContentDetailsItem">
                <div className="TournamentWidget-ContentDetailsItemTitle">ПРИЗ</div>
                <div className="TournamentWidget-ContentDetailsItemValue TournamentWidget-ContentDetailsItemValue--Prize">{data.get('prize')}</div>
              </div>
            }
          </div>
          ||
          status !== tournamentStatuses.finished.id
          &&
          <div className="TournamentWidget-ContentDetails">
            {getDates(data)}
          </div>
          }
          {status === tournamentStatuses.finished.id && !isListItem &&
            <div className="TournamentWidget-Winner">
              {data.get('winner') &&
                <div className="TournamentWidget-WinnerInfo">
                  <div className="TournamentWidget-WinnerInfoTitle">ПОБЕДИТЕЛЬ</div>
                  <div className="TournamentWidget-WinnerInfoValue">{data.getIn(['winner', 'title'])}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      {isListItem &&
        <div className='TournamentWidget-TopRightStatus'>
          {statusText}
        </div>
      }
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/TournamentAnnouncement.js